import { render, staticRenderFns } from "./SignUpStage.vue?vue&type=template&id=225abb4b&scoped=true&"
import script from "./SignUpStage.vue?vue&type=script&lang=ts&"
export * from "./SignUpStage.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpStage.vue?vue&type=style&index=0&id=225abb4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225abb4b",
  null
  
)

export default component.exports